import * as React from 'react';

import { withModal } from 'components/modal/ModalHOC';
import GalleryModal from 'components/gallery-modal/gallery-modal/GalleryModal';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import ContentListResultsContext from '../../context/ContentListResultsContext';
import { WITH_GALLERY_MODAL_CONFIG } from 'utils/gallery';

import type { GalleryModalItem } from 'types';

import './content-list-image-tile.scss';
import { getCloudinaryImageUrl } from 'utils/cloudinary';

type Props = {
  index: number,
  imageUrl: string,
  canDownload?: boolean,
  isSelected: boolean | undefined | null,
  onGalleryModalLastPage: () => void,
  onToggleSelect: () => void,
  renderCustomAsset?: ((b: GalleryModalItem, a: number) => React.ReactNode) | null
};

const ImageWithModal = withModal(<img alt="" />, {
  ...WITH_GALLERY_MODAL_CONFIG,
  modalContent: (props) => (
    <ContentListResultsContext.Consumer>
      {(results) => <GalleryModal {...props} items={results} />}
    </ContentListResultsContext.Consumer>
  )
});

const ContentListImageTile = (
  {
    index,
    imageUrl,
    canDownload,
    isSelected,
    onGalleryModalLastPage,
    onToggleSelect,
    renderCustomAsset
  }: Props
): JSX.Element => {
  const cloudinaryImageUrl = getCloudinaryImageUrl({ url: imageUrl }, {
    width: 250,
    height: 250
  });

  return (
    <div className="content-list-image-tile">
      <div className="content-list-image-tile__content">
        <ImageWithModal
          className="content-list-image-tile__image lazyload"
          data-src={cloudinaryImageUrl}
          modalContentProps={{
            theme: 'white',
            onLastPage: onGalleryModalLastPage,
            currentPosition: index,
            renderCustomAsset
          }}
        />
      </div>
      {
        canDownload && (
          <div className="content-list-image-tile__overlay">
            <div className="content-list-image-tile__item-selectable-icon">
              <SVGDynamicIcon
                name={isSelected ? 'checkmark-inside-circle-custom-bg-white-fg' : 'checkmark-inside-circle-custom-bg'}
                width={24}
                height={24}
                customColor={isSelected ? 'primary' : 'white'}
                onClick={onToggleSelect}
              />
            </div>
          </div>
        )
      }
    </div>
  );
};

export default ContentListImageTile;
